import { Component, OnInit, ViewChild } from '@angular/core'
import { SendForBankHistory, SendForBankStatus } from 'src/api/invoice-leaf/invoice-leaf-api.interface'
import { InvoiceLeafApiService } from 'src/api/invoice-leaf/invoice-leaf-api.service'
import { MessageService } from 'src/app/components/message/message.service'
import { SelectOption } from 'src/app/module/common-parts/select/select.component.interface'
import { GridActionButton, ActionTargetInfo } from 'src/app/module/is-grid/action-grid/action-grid.component.interface'
import { Header, RowSelection } from 'src/app/module/is-grid/base-grid/base-grid.component.interface'
import moment from 'moment'
import { sortedItems } from 'src/app/common/common'
import { messageList } from 'src/app/components/message/message-data'

@Component({
  selector: 'app-ura-send-invoice-for-bank',
  templateUrl: './ura-send-invoice-for-bank.component.html',
  styleUrls: ['./ura-send-invoice-for-bank.component.scss']
})
export class UraSendInvoiceForBankComponent implements OnInit {
  title = '口座振替・入金消込'
  periods: SelectOption[] = []
  period: string = ''
  data: SendForBankStatus[] = []
  columns: Header[] = [
    {
      key: 'invoiceKeyNumber',
      label: '請求書No.',
      width: '9%'
    },
    {
      key: 'suppliCustomerId',
      label: '請求先ID',
      width: '8%'
    },
    {
      key: 'deadlineDateUi',
      label: '振替日',
      width: '7%',
      style: {
        textAlign: 'center'
      }
    },
    {
      key: 'totalBillUi',
      label: '金額',
      width: '8%',
      style: {
        textAlign: 'rigth'
      }
    },
    {
      key: 'corporateNumber',
      label: '法人番号',
      width: '9%'
    },
    {
      key: 'companyOrganizaionFomalName',
      label: '会社名',
      width: '15%'
    },
    {
      key: 'customerName',
      label: '請求担当者',
      width: '9%'
    },
    {
      key: 'paymentTypeName',
      label: '月・年払い',
      width: '7%',
      style: {
        textAlign: 'center'
      }
    },
    {
      key: 'bankStatusName',
      label: '振替依頼',
      width: '7%',
      style: {
        textAlign: 'center'
      }
    },
    {
      key: 'bankResultStatusName',
      label: '振替結果',
      width: '7%',
      style: {
        textAlign: 'center'
      }
    },
    {
      key: 'withdrawalResultStatusName',
      label: '入金消込',
      width: '7%',
      style: {
        textAlign: 'center'
      }
    }
  ]
  rowSelection = RowSelection.MULTIPLE
  actionButtons: GridActionButton[] = [
    {
      label: '振替依頼送信',
      actionCd: 'send',
      confirmDialog: true
    },
    {
      label: '処理履歴確認',
      actionCd: 'history'
    },
    {
      label: '振替結果受信・入金消込',
      actionCd: 'receive',
      confirmDialog: true,
      notRowAction: true,
      actionFunction: () => {
        this.receive(this.period)
      }
    }
  ]
  loading = true
  sending = false
  cellClasses = {
    color_gray: (rowData: SendForBankStatus, columnKey: string): boolean => {
      return (
        (columnKey === 'bankResultStatusName' && rowData.bankStatusCd !== 2 && rowData.bankResultStatusCd === null) ||
        (columnKey === 'withdrawalResultStatusName' && (rowData.bankStatusCd !== 2 || rowData.bankResultStatusCd !== 0) && rowData.withdrawalResultStatusCd === null)
      )
    },
    color_green: (rowData: SendForBankStatus, columnKey: string): boolean => {
      return (
        (columnKey === 'bankStatusName' && rowData.bankStatusCd === 2) ||
        (columnKey === 'bankResultStatusName' && rowData.bankResultStatusCd === 0) ||
        (columnKey === 'withdrawalResultStatusName' && rowData.withdrawalResultStatusCd === 0)
      )
    },
    color_red: (rowData: SendForBankStatus, columnKey: string): boolean => {
      return (
        (columnKey === 'bankStatusName' && rowData.bankStatusCd !== 2) ||
        (columnKey === 'bankResultStatusName' && rowData.bankResultStatusCd !== 0) ||
        (columnKey === 'withdrawalResultStatusName' && rowData.withdrawalResultStatusCd !== 0)
      )
    }
  }
  dialogOpen = false
  detailDialogOpen = false
  infoDialogOpen = false
  bankTranDateAlertDialogOpen = false
  missingBankTranDates: string[] = []
  history: SendForBankHistory[] = []
  historyDetail: string = ''

  constructor(
    private messageService: MessageService,
    private invoiceLeafApiService: InvoiceLeafApiService
  ) {}

  ngOnInit(): void {
    this.getPeriods()
    this.checkBankTranDateMasterAlert()
  }

  async checkBankTranDateMasterAlert(): Promise<void> {
    const ret = await this.invoiceLeafApiService.GetBankTranDates()
    if (ret?.resultCode !== 0) {
      return
    }

    const registeredDateSet = new Set(ret.data.map((row) => this.toInputDate(row.tranDate)))
    const missingDates: string[] = []
    const today = new Date()

    for (let monthOffset = 0; monthOffset < 3; monthOffset++) {
      const targetMonth = new Date(today.getFullYear(), today.getMonth() + monthOffset, 1)
      const monthEnd = this.getMonthEndDate(targetMonth.getFullYear(), targetMonth.getMonth())
      const monthEndText = this.toInputDate(monthEnd)
      if (!registeredDateSet.has(monthEndText)) {
        missingDates.push(this.toDisplayYearMonth(monthEnd))
      }
    }

    if (missingDates.length) {
      this.missingBankTranDates = missingDates
      this.bankTranDateAlertDialogOpen = true
    }
  }

  async getPeriods(): Promise<void> {
    this.periods = []
    this.loading = true
    const ret = await this.invoiceLeafApiService.GetTargetYearMonth()
    this.loading = false
    if (ret?.resultCode !== 0) {
      return
    }
    ret.data.forEach((date) => {
      var dateArray = date.split('-')
      const selectOption: SelectOption = {
        label: `${dateArray[0]}年${dateArray[1]}月 サービス利用分`,
        value: date
      }
      this.periods.push(selectOption)
    })
    this.period = this.periods[0].value
    this.getList(this.period)
  }

  async getList(period: string): Promise<void> {
    this.data = []
    this.loading = true
    const ret = await this.invoiceLeafApiService.GetSendForBankStatus(period.replace('-', ''))
    this.loading = false
    if (ret?.resultCode !== 0) {
      return
    }
    this.data = ret.data
    this.data.forEach((item) => {
      item.totalBillUi = `\\${item.totalBill.toLocaleString()}`
      item.actionCds = ['history']
      if (item.bankStatusCd !== 2) {
        item.actionCds.push('send')
      }
    })
  }

  async send(invoiceDataCds: string[]): Promise<void> {
    this.sending = true
    const ret = await this.invoiceLeafApiService.SendToBank(invoiceDataCds)
    this.sending = false
    this.getList(this.period)
    if (ret?.resultCode !== 0) {
      return
    }
    this.messageService.success('送信処理を実行しました')
  }

  async receive(period: string): Promise<void> {
    this.sending = true
    const ret = await this.invoiceLeafApiService.ReceiveFromBank(period.replace('-', ''))
    this.sending = false
    this.getList(this.period)
    if (ret?.resultCode !== 0) {
      this.messageService.error(ret.resultMessage ?? messageList.M00001.message)
      return
    }
    this.messageService.success(ret.data)
  }

  async getSendBankHistory(invoiceDataCd: string): Promise<void> {
    this.history = []
    this.loading = true
    const historyRet = await this.invoiceLeafApiService.GetSendBankHistory(invoiceDataCd)
    this.loading = false
    if (historyRet?.resultCode !== 0) {
      return
    }
    this.history = sortedItems(historyRet.data, 'updatedAt', false)
    this.history.forEach((item) => {
      item.updatedDatetimeUi = moment(item.updatedAt).format('YYYY-MM-DD HH:mm:ss')
    })
  }

  actionCommit(event: ActionTargetInfo): void {
    if (this.sending) {
      return
    }
    if (event.actionCd === 'history') {
      if (event.rows.length > 1) {
        this.messageService.warning('1件のみ選択して下さい')
      }
      this.dialogOpen = true
      this.getSendBankHistory(event.rows[0].invoiceDataCd)
    }
    if (event.actionCd === 'send') {
      const invoiceDataCds: string[] = []
      event.rows.forEach((row) => {
        invoiceDataCds.push(row.invoiceDataCd)
      })
      this.send(invoiceDataCds)
    }
  }

  closeBankTranDateAlertDialog(): void {
    this.bankTranDateAlertDialogOpen = false
  }

  openInfoDialog(): void {
    this.infoDialogOpen = true
  }

  closeInfoDialog(): void {
    this.infoDialogOpen = false
  }

  private getMonthEndDate(year: number, month: number): Date {
    return new Date(year, month + 1, 0)
  }

  private toInputDate(value: string | Date): string {
    if (!value) {
      return ''
    }

    if (typeof value === 'string' && value.match(/^\d{4}-\d{2}-\d{2}$/)) {
      return value
    }

    const date = value instanceof Date ? value : new Date(value)
    const year = date.getFullYear()
    const month = `${date.getMonth() + 1}`.padStart(2, '0')
    const day = `${date.getDate()}`.padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  private toDisplayYearMonth(value: Date): string {
    const year = value.getFullYear()
    const month = `${value.getMonth() + 1}`.padStart(2, '0')
    return `${year}/${month}`
  }
}
